/**
 * Helper to dispatch custom events from Election Hub.
 *
 * @export
 * @param {object} detail Event details.
 */
export default function sendCustomEvent(detail) {
  document.dispatchEvent(
    new CustomEvent('ElectionHub', {
      detail,
    }),
  );
}
